const parseToken = token => {
  if (typeof window !== undefined) {
    try {
      return JSON.parse(window.atob(token.split('.')[1]));
    } catch (e) {
      return {};
    }
  }
};

export default parseToken;
